import { Component, inject, effect, untracked, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { RendererDirective } from '../../core/dynamic/renderer';
import { SideNavSignal } from '../../signal';

@Component({
    selector: 'app-side',
    imports: [CommonModule, MatIcon, RendererDirective],
    templateUrl: './side.component.html',
    styleUrls: ['./side.component.scss']
})
export class SideComponent {
    private readonly sideNavSignal = inject(SideNavSignal);

    data = computed(() => this.sideNavSignal.render());

    public onClose(): void {
        this.sideNavSignal.render.set(null);
    }
}
